<ng-container *ngFor="let item of itemList; let index = index">
	<ng-template [ngIf]="selections[index]">
		<diV class="row">
			<div [ngClass]="fieldClass">
				<div class="input-group">
					<input
						[disabled]="disabled"
						type="text"
						class="form-control"
						[value]="labelGetter(item)"
						readonly />
					<div class="input-group-addon">
						<a class="" href="#" onclick="return false;" title="Retirer" (click)="onDeselectItem(index)">
							<span [ngClass]="'fa fa-minus-circle fa-lg' + (disabled ? ' disabled' : '')"></span>
						</a>
					</div>
				</div>
			</div>
			<ng-container
				[ngTemplateOutlet]="notesTemplate"
				[ngTemplateOutletContext]="{ $implicit: item }"
			></ng-container>
		</diV>
	</ng-template>
</ng-container>
<div class="row">
	<div [ngClass]="fieldClass">
		<extended-filterable-select *ngIf="!disabled && showSelect"
			[id]="id"
			[disabled]="disabled"
			[inputClass]="'form-control'"
			[selectClass]="'form-control'"
			[list]="wrappedItems"
			[labelGetter]="getWrappedItemLabel"
			[categoryList]="categoryList"
			[categoryLabelGetter]="categoryLabelGetter"
			[wildcardCategoryLabel]="wildcardCategoryLabel"
			[categoryChecker]="wrappedItemCategoryChecker"
			[actionIconClass]="'fa-plus-circle'"
			[actionTitle]="''"
			[actionFunction]="doNothing"
			[selectedItem]="selectedItem"
			(selectedItemChange)="onSelectItem($event)"
			>
		</extended-filterable-select>
	</div>
</div>
<div class="row" *ngIf="shouldShowAddOrRemoveAll()">
	<div [ngClass]="['text-center', fieldClass]">
		<a href="#" [ngClass]="disabled ? 'disabled' : ''" onclick="return false;" (click)="onSelectAll()">Tout ajouter</a>
		<span>&nbsp;/&nbsp;</span>
		<a href="#" [ngClass]="disabled ? 'disabled' : ''" onclick="return false;" (click)="onDeselectAll()">Tout retirer</a>
	</div>
</div>